<nb-card>
  <nb-card-header>
    {{ history.fullName }} , năm sinh: {{ history.dobYear }}
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <form [formGroup]="diaForm">
      <div class="form-group">
        <label class="label">{{ "common.status" | translate }}</label>
        <nb-select
          outline
          fullWidth
          shape="round"
          [status]="
            history.value == 1
              ? 'success'
              : history.value == 0
              ? 'info'
              : 'danger'
          "
          size="small"
          placeholder="Chọn lý do"
          formControlName="value"
          (selectedChange)="selectedStatus($event)"
          [(ngModel)]="history.value"
        >
          <nb-option *ngFor="let item of status" [value]="item.value">
            {{ item.name }}</nb-option
          >
        </nb-select>
      </div>

      <div class="form-group">
        <label class="label"> {{ "common.note" | translate }} </label>
        <textarea
          nbInput
          fullWidth
          id="inputDescription"
          class="form-control"
          formControlName="description"
          [(ngModel)]="history.description"
        ></textarea>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
